<template>
	<v-container>
		<v-row>
			<v-col>
				<div
					class="d-flex justify-space-between mt-8"
					:class="{
						'flex-column align-start': $vuetify.breakpoint.mdAndDown,
					}"
				>
					<div class="text-h4 font-weight-bold primary--text">
						All Transactions
					</div>
					<!--  -->
					<!-- <v-btn depressed color="primary" class="py-6 text-none"
          >Generate Report</v-btn
        > -->
				</div>
				<v-card flat class="mt-10 rounded-xl secondary--border overflow-y-auto">
					<v-data-table
						:headers="headers"
						:items="transactions"
						:items-per-page="itemsPerPage"
						hide-default-footer
						auto-height
						:loading="isFetchingTransactions"
					>
						<template v-slot:header.date="{ header }">
							<div
								class="py-6 px-5 text-body-1 font-weight-bold primary--text d-flex align-center"
							>
								<span class="mr-1">{{ header.text }}</span>
								<hm-icon height="18" width="30">
									<sort-icon />
								</hm-icon>
							</div>
						</template>
						<template v-slot:header.action="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:header.created_at="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:header.type="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:header.amount="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:item.createdat="{ item }">
							<div class="text-body-1">
								{{ formatDate(item.createdat) }}
							</div>
						</template>
						<template v-slot:item.description="{ item }">
							<div class="text-body-1">
								{{ item.description }}
							</div>
						</template>
						<template v-slot:item.transactiontype="{ item }">
							<div class="text-body-1 text-capitalize">
								{{ item.transactiontype }}
							</div>
						</template>
						<template v-slot:item.amount="{ item }">
							<div class="text-body-1 text-capitalize">
								{{ formatMoney(item.amount) }}
							</div>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
			<v-col cols="12">
				<div class="text-center pt-2">
					<v-pagination v-model="page" :length="pageCount"></v-pagination>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { TransactionService } from "@/services/index.js";
	import HmIcon from "@/components/HmIcon.vue";
	import SortIcon from "@/components/icons/dashboard/SortIcon.vue";
	import { formatMoney, formatDate } from "@/utils/helpers";

	export default {
		components: {
			HmIcon,
			SortIcon,
		},
		data() {
			return {
				page: 1,
				itemsPerPage: 2,
				total: 0,
				isFetchingTransactions: false,
				transactions: [],
				formatMoney,
				formatDate,
				headers: [
					{
						text: "Date",
						align: "start",
						sortable: false,
						value: "createdat",
					},
					{ text: "Action Taken", value: "description", sortable: false },
					// { text: "Time", value: "time", sortable: false },
					{ text: "Payment Type", value: "transactiontype", sortable: false },
					{ text: "Amount Paid", value: "amount", sortable: false },
				],
			};
		},
		computed: {
			pageCount() {
				return (
					Math.round(this.total / this.itemsPerPage) +
					(this.total % this.itemsPerPage > 0 ? 1 : 0)
				);
			},
		},
		methods: {
			async getTransactions() {
				try {
					this.isFetchingTransactions = true;

					const {
						data: { data: transactions, lastPage, perPage, total },
					} = await TransactionService.getWalletTransactions(this.page);
					this.transactions = transactions;
					this.itemsPerPage = perPage;
					this.total = total;

					this.isFetchingTransactions = false;
				} catch (error) {
					this.isFetchingTransactions = false;

					// throw error;
				}
			},
		},
		created() {
			this.getTransactions();
		},
		watch: {
			page() {
				this.getTransactions();
			},
		},
	};
</script>
